<template>
  <ss-modal
    v-show="isModalVisible"
    class="xl"
    title="Title"
    intro="bounceIn"
    outro="bounceOut">
    <!-- HEADER -->
    <div slot="modal-header">
      <template v-if="!isAddNew">
        Edycja poręczyciela
      </template>
      <template v-else>
        Nowy poręczyciel
      </template>
      <i class="close" @click="closeModal(false)"></i>
    </div>
    <!-- BODY -->
    <div slot="modal-body" >
        <guarantor :props.sync="guarantor" />
    </div>
    <!-- FOOTER -->
    <div slot="modal-footer">
      <d-button
        @click.prevent="closeModal(false)"
        :class="{ disabled : actionInProgress }"
        theme="danger">
        <i class="material-icons">close</i> Zamknij
      </d-button>
      <d-button
        @click.prevent="saveGuarantor"
        :class="{ isLoading: actionInProgress }"
        theme="success" class="ml-3">
        <i class="material-icons">save</i> Zapisz
      </d-button>
    </div>
  </ss-modal>
</template>

<script>
import ClientUtils from '@/utils/client';
import SsModal from '@/components/common/SsModal'
import LarErrors from '@/helpers/Errors';
import Guarantor from '@/components/client/Guarantor.vue';

export default {
  name: 'GuarantorFormModal',
  components: {
    ClientUtils,
    SsModal,
    LarErrors,
    Guarantor
  },
  props: {
    isModalVisible: {
      default: false,
      type: Boolean
    },
    selectedGuarantor: {
      type: Object,
      default: null
    }
  },
  watch: {
    isModalVisible (newValue) {
      if (newValue) {
        this.guarantor = this.selectedGuarantor;
      } else {
        this.guarantor = _.clone(ClientUtils._guarantor);
      }
    }
  },
  computed: {
    isAddNew () {
      return this.selectedGuarantor && this.selectedGuarantor.id;
    }
  },
  data () {
    return {
      actionInProgress: false,
      guarantor: null
    }
  },
  methods: {
    saveGuarantor () {
      this.actionInProgress = true;
      let guarantorToSave = this.guarantor;

      axios.post(
        'api/guarantors/save-guarantor',
        guarantorToSave
      ).then(response => {
        Vue.swal({
          type: 'success',
          title: 'Poręczyciel został zapisany.',
          showConfirmButton: true,
        }).then(() => {
          this.closeModal(true);
        });
        this.actionInProgress = false;
      }).catch((error) =>{
        Vue.swal({
          type: 'error',
          title: error.response.data.message,
          html: Vue.transformErrorsToHtml(error.response.data.errors),
          showConfirmButton: true,
        });
        this.actionInProgress = false;
        LarErrors.record(error.response.data.errors)
      })
    },
    closeModal (shouldReload = false) {
      this.$bus.$emit('guarantor-form-modal-close', shouldReload);
    }
  }
}
</script>
